import React, { type FunctionComponent } from 'react'
import { Redirect } from 'react-router'
import { URL_STORE_GROUPS } from 'utils/routing/routes'
import RetailerSwitch from 'legacy/components/RetailerSwitch'
import RetailerRoute from 'legacy/components/RetailerRoute'
import { StoreGroupsList } from 'legacy/sections/store-groups/components/list/StoreGroupsList'
import { StoreGroupsAdd } from 'legacy/sections/store-groups/components/add/StoreGroupsAdd'
import { StoreGroupsEdit } from 'legacy/sections/store-groups/components/edit/StoreGroupsEdit'

export const StoreGroupsSection: FunctionComponent = () => (
  <RetailerSwitch>
    <RetailerRoute exact route="store-groups" component={StoreGroupsList} />
    <RetailerRoute exact route="store-groups-add" component={StoreGroupsAdd} />
    <RetailerRoute exact route="store-groups-edit" component={StoreGroupsEdit} />
    <Redirect to={URL_STORE_GROUPS} />
  </RetailerSwitch>
)
